import React from "react";

// Icônes des 7 catégories FAST (ex-QUICK, renommé — la communauté n'a pas adhéré au nom) —
// dessinées à la main, même convention que les icônes de Layout.tsx (viewBox 24×24, fill="none"
// stroke={color} strokeWidth={2}, uniquement path/circle/polygon/line — jamais de rect ni de
// dégradé interne à l'icône). Liste volontairement courte et statique (curée par le fondateur,
// pas un catalogue proposé/modéré comme Passions/Powers) — facile à étendre en ajoutant une
// entrée ici + dans FAST_CATEGORIES.
type IconProps = { color?: string; size?: number };

export const CafeIcon = ({ color = "currentColor", size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 8h13v6a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5z" />
    <path d="M17 9h1.5a2.5 2.5 0 0 1 0 5H17" />
    <line x1="8" y1="2" x2="8" y2="4" />
    <line x1="12" y1="2" x2="12" y2="4" />
  </svg>
);

export const VerreIcon = ({ color = "currentColor", size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16l-8 9z" />
    <line x1="12" y1="13" x2="12" y2="21" />
    <line x1="8" y1="21" x2="16" y2="21" />
  </svg>
);

export const BaladeIcon = ({ color = "currentColor", size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    {/* Empreintes de pas — cercles REMPLIS (pas de simples anneaux, illisibles en petite taille,
        confondus avec un diagramme de réseau) pour se lire immédiatement comme des pas. */}
    <circle cx="7" cy="16" r="2.3" fill={color} stroke="none" />
    <circle cx="8.5" cy="11" r="1.1" fill={color} stroke="none" />
    <circle cx="16" cy="8" r="2.3" fill={color} stroke="none" />
    <circle cx="14.5" cy="3" r="1.1" fill={color} stroke="none" />
  </svg>
);

export const MangerIcon = ({ color = "currentColor", size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    {/* Fourchette seule — le cercle + diagonales croisées d'origine se lisait comme un panneau
        "interdit", pas comme de la vaisselle. Un ustensile unique évite toute ambiguïté. */}
    <line x1="7" y1="2" x2="7" y2="9" />
    <line x1="10" y1="2" x2="10" y2="9" />
    <line x1="13" y1="2" x2="13" y2="9" />
    <path d="M7 9c0 2.2 6 2.2 6 0" />
    <line x1="10" y1="9" x2="10" y2="22" />
  </svg>
);

export const ActiviteIcon = ({ color = "currentColor", size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="7" y1="12" x2="17" y2="12" />
    <line x1="4" y1="9" x2="4" y2="15" />
    <line x1="20" y1="9" x2="20" y2="15" />
    <line x1="7.5" y1="8" x2="7.5" y2="16" />
    <line x1="16.5" y1="8" x2="16.5" y2="16" />
  </svg>
);

export const SortieIcon = ({ color = "currentColor", size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3l1.8 6.2L20 11l-6.2 1.8L12 19l-1.8-6.2L4 11l6.2-1.8z" />
    <circle cx="19" cy="5" r="1.1" />
    <circle cx="5" cy="18" r="1.1" />
  </svg>
);

export const RejoindreIcon = ({ color = "currentColor", size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 21v-8a1.5 1.5 0 0 1 3 0v4" />
    <path d="M11 17V5a1.5 1.5 0 0 1 3 0v9" />
    <path d="M14 17V6a1.5 1.5 0 0 1 3 0v8" />
    <path d="M17 14V9a1.5 1.5 0 0 1 3 0v7c0 3.9-2.7 6-6 6h-1c-2.5 0-4-1-5-3l-2-4a1.3 1.3 0 0 1 2.2-1.3L9 15" />
  </svg>
);

// Pin/horloge — remplacent les emoji 📍/🕐 utilisés pour le lieu et l'heure d'un FAST (FastCard,
// bouton géolocalisation) : même convention de trait que les icônes de catégorie ci-dessus.
export const PinIcon = ({ color = "currentColor", size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 21s7-7.16 7-12a7 7 0 0 0-14 0c0 4.84 7 12 7 12z" />
    <circle cx="12" cy="9" r="2.4" />
  </svg>
);

export const ClockIcon = ({ color = "currentColor", size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3.2 2" />
  </svg>
);

// Globe/deux-personnes — remplacent les emoji 🌍/👥 de l'audience Public/Amis (3ème fois que ça
// revient : plus jamais d'emoji en dur dans un label, toujours une vraie icône passée à part).
export const GlobeIcon = ({ color = "currentColor", size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18" />
    <path d="M12 3a14 14 0 0 1 0 18a14 14 0 0 1 0-18" />
  </svg>
);

// Même tracé que le pictogramme "communauté" de GLYPH_PATHS (Explore.tsx) — un groupe de
// personnes se lit aussi bien pour "mes amis" que pour "communauté".
export const FriendsIcon = ({ color = "currentColor", size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="8" r="3.2" />
    <path d="M2.5 20c0-3.6 2.9-5.8 6.5-5.8s6.5 2.2 6.5 5.8" />
    <path d="M16 5.2a3.2 3.2 0 0 1 0 6" />
    <path d="M17.5 14.6c2.4.6 4 2.4 4 5.4" />
  </svg>
);

// L'éclair — repris tel quel de l'ancienne icône des Powers (même tracé, mêmes proportions),
// retiré de Powers (remplacé par le bras de SkillIcons.tsx) et donné à FAST : seule sa couleur
// change (doré). C'est ce même éclair qui apparaît dans le losange de la carte, le badge des
// cards, et le bouton Explorer — une identité visuelle unique plutôt qu'un symbole par endroit.
export const LIGHTNING_PATH = `<polygon points="13,2 4,13.6 10.6,13.6 9.7,22 20,10 13.1,10" fill="currentColor" stroke="none"/>`;

export const LightningIcon = ({ color = "currentColor", size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="none" dangerouslySetInnerHTML={{ __html: LIGHTNING_PATH.replace(/currentColor/, color) }} />
);

// "trajet" n'est jamais choisie dans le sélecteur manuel (FastCreateSheet.tsx filtre cette
// entrée) — réservée aux FAST créés automatiquement par MOVE ("On My Way", voir
// routes/publications.ts#POST /:id/on-my-way) — mais reste une clé normale ici pour que ces FAST
// s'affichent avec un vrai libellé/une vraie icône partout où un FAST classique s'affiche
// (FastCard, Explore.tsx), au lieu de retomber sur le "FAST" générique.
export type FastCategoryKey = "cafe" | "verre" | "balade" | "manger" | "activite" | "sortie" | "rejoindre" | "trajet";

export const TrajetIcon = ({ color = "currentColor", size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 17h2a1 1 0 0 0 1-1v-3c0-.9-.6-1.7-1.5-1.9L17 10s-1.3-1.4-2.2-2.3a2 2 0 0 0-1.4-.7H6c-.6 0-1.1.3-1.4.8L3 10.7A3.5 3.5 0 0 0 2 13v3c0 .6.4 1 1 1h2" />
    <path d="M9 17h6" />
    <circle cx="7" cy="17" r="2" />
    <circle cx="17" cy="17" r="2" />
  </svg>
);

export const FAST_CATEGORIES: { key: FastCategoryKey; label: string; sub: string; Icon: React.ComponentType<IconProps>; emoji: string }[] = [
  { key: "cafe", label: "Café", sub: "Prendre un café", Icon: CafeIcon, emoji: "☕" },
  { key: "verre", label: "Verre", sub: "Boire un verre", Icon: VerreIcon, emoji: "🍸" },
  { key: "balade", label: "Balade", sub: "Faire une balade", Icon: BaladeIcon, emoji: "🚶" },
  { key: "manger", label: "Manger", sub: "Manger quelque chose", Icon: MangerIcon, emoji: "🍽️" },
  { key: "activite", label: "Activité", sub: "Faire une activité", Icon: ActiviteIcon, emoji: "🏃" },
  { key: "sortie", label: "Sortie", sub: "Sortir, faire quelque chose", Icon: SortieIcon, emoji: "🎉" },
  { key: "rejoindre", label: "Me rejoindre", sub: "Me rejoindre quelque part", Icon: RejoindreIcon, emoji: "👋" },
  { key: "trajet", label: "Trajet", sub: "En route pour un trajet Move", Icon: TrajetIcon, emoji: "🚗" },
];

// Catégories réellement proposées dans le sélecteur de création manuel (FastCreateSheet.tsx) —
// "trajet" en est exclue, voir le commentaire sur FastCategoryKey ci-dessus.
export const FAST_CREATABLE_CATEGORIES = FAST_CATEGORIES.filter(c => c.key !== "trajet");

export const FAST_CATEGORY_LABELS: Record<FastCategoryKey, string> = Object.fromEntries(
  FAST_CATEGORIES.map(c => [c.key, c.label])
) as Record<FastCategoryKey, string>;
